import React from 'react';
import styled from 'styled-components';

const EducationContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 6rem 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 3rem;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 50px;
    height: 3px;
    background-color: var(--secondary-color);
    margin: 0.5rem auto 0;
  }
`;

const EducationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 1.5rem;
  max-width: 900px;
  margin: 0 auto;
`;

const EducationCard = styled.div`
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  padding: 1.75rem;
  display: flex;
  gap: 1.25rem;
  transition: var(--transition);

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-sm);
  }
`;

const IconWrap = styled.div`
  font-size: 2rem;
  line-height: 1;
  flex-shrink: 0;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

const Degree = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: var(--primary-color);
`;

const Institution = styled.p`
  font-size: 0.925rem;
  color: var(--secondary-color);
  font-weight: 600;
`;

const Period = styled.p`
  font-size: 0.875rem;
  color: var(--dark-gray);
  font-style: italic;
`;

const Detail = styled.p`
  font-size: 0.875rem;
  color: var(--dark-gray);
  margin-top: 0.25rem;
`;

const Badge = styled.span`
  display: inline-block;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  background-color: #eff6ff;
  color: var(--secondary-color);
  border: 1px solid #bfdbfe;
  width: fit-content;
`;

const Education = () => {
  const entries = [
    {
      icon: '🎓',
      degree: 'B.E. in Computer Engineering',
      institution: 'M.H. Saboo Siddik College of Engineering',
      location: 'Mumbai, India',
      period: 'Aug 2018 – July 2022',
      detail: 'CGPA: 8.6 / 10',
      badge: 'First Class with Distinction',
    },
    {
      icon: '📘',
      degree: 'HSC — PCM + Computer Science',
      institution: "Royal College of Art's, Science and Commerce",
      location: 'Mumbai, India',
      period: 'Aug 2016 – July 2018',
      detail: 'Percentage: 82.92%',
      badge: null,
    },
  ];

  return (
    <EducationContainer>
      <SectionTitle>Education</SectionTitle>
      <EducationGrid>
        {entries.map((entry, i) => (
          <EducationCard key={i}>
            <IconWrap>{entry.icon}</IconWrap>
            <CardBody>
              <Degree>{entry.degree}</Degree>
              <Institution>{entry.institution}</Institution>
              <Period>{entry.location} &nbsp;·&nbsp; {entry.period}</Period>
              <Detail>{entry.detail}</Detail>
              {entry.badge && <Badge>{entry.badge}</Badge>}
            </CardBody>
          </EducationCard>
        ))}
      </EducationGrid>
    </EducationContainer>
  );
};

export default Education;
